/**
 * Real Photo Lightbox JS
 */
(function() {
  class RealPhotoLightbox {
    constructor() {
      this.lightbox = document.getElementById('RealPhotoLightbox');
      if (!this.lightbox) return;

      this.slider = this.lightbox.querySelector('.real-photo-lightbox__slider');
      this.prevBtn = this.lightbox.querySelector('.real-photo-lightbox__nav-btn--prev');
      this.nextBtn = this.lightbox.querySelector('.real-photo-lightbox__nav-btn--next');
      this.counter = this.lightbox.querySelector('.real-photo-lightbox__counter');
      this.closeBtn = this.lightbox.querySelector('.real-photo-lightbox__close');
      
      this.currentIndex = 0;
      this.slides = [];

      this.init();
    }

    init() {
      // Open lightbox when clicking on real photo images in drawer
      document.addEventListener('click', (e) => {
        const image = e.target.closest('.product-real-photo-image, .product-drawer-measurement-image');
        if (image && image.closest('.feedback-drawer')) {
          this.open(image);
        }
      });

      // Close events
      this.closeBtn.addEventListener('click', () => this.close());
      this.lightbox.addEventListener('click', (e) => {
        if (e.target === this.lightbox || e.target.classList.contains('real-photo-lightbox__container')) {
          this.close();
        }
      });

      // Nav events
      this.prevBtn.addEventListener('click', () => this.slide('prev'));
      this.nextBtn.addEventListener('click', () => this.slide('next'));

      // Slider scroll event for counter and buttons
      this.slider.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimeout);
        this.scrollTimeout = setTimeout(() => this.updateState(), 100);
      }, { passive: true });

      // Keyboard events
      document.addEventListener('keydown', (e) => {
        if (!this.lightbox.classList.contains('is-open')) return;
        
        if (e.key === 'Escape') this.close();
        if (e.key === 'ArrowLeft') this.slide('prev');
        if (e.key === 'ArrowRight') this.slide('next');
      });
    }

    open(clickedImage) {
      // Get all images in the same drawer
      const drawer = clickedImage.closest('.feedback-drawer');
      const allImages = Array.from(drawer.querySelectorAll('.product-real-photo-image, .product-drawer-measurement-image'));
      
      // Clear existing slides
      this.slider.innerHTML = '';
      this.slides = [];

      // Create slides for all images
      allImages.forEach((img, index) => {
        const slide = document.createElement('div');
        slide.className = 'real-photo-lightbox__slide';
        
        const fullImg = document.createElement('img');
        fullImg.src = img.src.split('&width=')[0] + '&width=2000'; // Get high res version
        fullImg.className = 'real-photo-lightbox__image';
        fullImg.loading = 'lazy';
        
        slide.appendChild(fullImg);
        this.slider.appendChild(slide);
        this.slides.push(slide);

        if (img === clickedImage) {
          this.currentIndex = index;
        }
      });

      this.lightbox.classList.add('is-open');
      document.body.classList.add('overflow-hidden');

      // Scroll to the clicked image slide
      setTimeout(() => {
        const targetSlide = this.slides[this.currentIndex];
        if (targetSlide) {
          this.slider.scrollTo({
            left: targetSlide.offsetLeft,
            behavior: 'auto'
          });
        }
        this.updateState();
      }, 50);
    }

    close() {
      this.lightbox.classList.remove('is-open');
      document.body.classList.remove('overflow-hidden');
    }

    slide(direction) {
      const step = this.slider.offsetWidth;
      const amount = direction === 'prev' ? -step : step;
      this.slider.scrollBy({ left: amount, behavior: 'smooth' });
    }

    updateState() {
      const scrollLeft = this.slider.scrollLeft;
      const width = this.slider.offsetWidth;
      this.currentIndex = Math.round(scrollLeft / width);

      this.prevBtn.disabled = this.currentIndex === 0;
      this.nextBtn.disabled = this.currentIndex === this.slides.length - 1;

      if (this.counter) {
        this.counter.textContent = `${this.currentIndex + 1} / ${this.slides.length}`;
      }
    }
  }

  // Initialize
  document.addEventListener('DOMContentLoaded', () => {
    window.realPhotoLightbox = new RealPhotoLightbox();
  });
})();
